import _ from "lodash";

/**
 * @description - Function for get workflow categories
 * @param workflowStates - all states with categories
 * @param stateType - selected workflow state type
 * @returns workflow categories
 */
export const getWorkflowCategoryOptions = (
  workflowStates: Array<any>,
  stateType: any
): Array<any> => {
  try {
    if (Array.isArray(workflowStates)) {
      return workflowStates?.flatMap((category) => {
        const { stateCategoryId, stateCategoryDisplayName, type } =
          category ?? {};

        if (stateType == type) {
          return {
            label: stateCategoryDisplayName,
            value: stateCategoryId,
          };
        } else {
          return [];
        }
      });
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

/**
 * @description - Function for format selected files for upload
 * @param uploadedFiles - all states with categories
 * @returns workflow categories
 */
export const getPackageDataForImport = async (
  uploadedFiles: Array<any>
): Promise<Array<any>> => {
  try {
    if (Array.isArray(uploadedFiles)) {
      let newUploadedFiles: any = [];
      const fileArray = Array.from(uploadedFiles);

      const promises = fileArray.map((file) => {
        return new Promise<any>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            if (e.target?.result) {
              resolve({
                isEnableReplace: file?.isEnableReplace ? true : false,
                jsonString: e.target.result,
              });
            } else {
              reject("Failed to read file");
            }
          };
          reader.onerror = () => reject("Error reading file");
          reader.readAsText(file);
        });
      });

      // Wait for all promises to resolve
      const contents = await Promise.all(promises);
      newUploadedFiles = [...contents];
      return newUploadedFiles;
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

/**
 * @description - Function for check if validation result has errors
 * @param uploadedResult - uploaded files
 * @returns wether the result has errors
 */
export const resultHasErrors = (uploadedResult: Array<any>): boolean => {
  try {
    if (Array.isArray(uploadedResult)) {
      return _.some(
        uploadedResult?.filter(
          ({ errorCode }: any) => errorCode != 3 && errorCode != 4
        ),
        { isError: true }
      );
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};
